'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BILLING = exports.BILLING = 'billing';
var TEAM = exports.TEAM = 'team';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/constants/AdminTypes.js
// module id = 132
// module chunks = 3 4 5